document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-el-banner-timer]");
  if (!sections.length) return;

  const pad = (value) => String(value).padStart(2, "0");

  const getInitialTargetDate = (section) => {
    const targetDate = section.dataset.targetDate || "";
    const targetTime = section.dataset.targetTime || "00:00:00";
    if (!targetDate) return null;

    const normalizedTime =
      targetTime.length === 5 ? `${targetTime}:00` : targetTime;
    const localDate = new Date(`${targetDate}T${normalizedTime}`);

    return Number.isNaN(localDate.getTime()) ? null : localDate;
  };

  sections.forEach((section) => {
    const hoursEls = section.querySelectorAll("[data-el-hours]");
    const minutesEls = section.querySelectorAll("[data-el-minutes]");
    const secondsEls = section.querySelectorAll("[data-el-seconds]");
    let target = getInitialTargetDate(section);

    if (!hoursEls.length || !minutesEls.length || !secondsEls.length || !target)
      return;

    const updateCountdown = () => {
      const now = new Date();

      while (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }

      const diff = target.getTime() - now.getTime();
      const totalSeconds = Math.floor(diff / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hoursEls.forEach((el) => (el.textContent = pad(hours)));
      minutesEls.forEach((el) => (el.textContent = pad(minutes)));
      secondsEls.forEach((el) => (el.textContent = pad(seconds)));
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
